import { object, string } from 'yup';


export const LoginSchema = object({
    email: string().required('Email ou numéro mobile Obligatoire!!'),
    password: string().required('Mot de passe Obligatoire!!'),
    
  });